import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router';

import { priceFormat, priceFormatSeparate } from 'apps/products/utils/priceFormat';
import basketModes from 'apps/basket/utils/basketModes';
import { wa } from 'apps/analytics';
import PageEvents from 'apps/header/models/PageEvents';
import { fetchBasket } from 'apps/basket/actions/basket';
import { dataSync } from 'apps/dataSync';

import { links } from '[theme-lib]/links';

import BasketSummaryEdit from '../containers/BasketSummaryEdit';

export default class BasketSummary extends PureComponent {
  static propTypes = {
    basket: PropTypes.shape({
      mode: PropTypes.oneOf(Object.values(basketModes)).isRequired,
      value: PropTypes.number.isRequired,
      minimumOrderValue: PropTypes.number.isRequired,
      numberOfItems: PropTypes.number.isRequired,
      offerSavings: PropTypes.number.isRequired,
    }).isRequired,
    isDesktopBreakpoint: PropTypes.bool.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    openTrolleyMenu: PropTypes.func.isRequired,
  };

  componentDidMount() {
    dataSync.appendAction('basketSync', fetchBasket, 20000);
  }

  componentWillUnmount() {
    dataSync.removeAction('basketSync');
  }

  onBasketSummaryClick = (event) => {
    if (this.props.isDesktopBreakpoint) {
      return;
    }

    event.preventDefault();
    this.props.openTrolleyMenu();
    wa.triggerPageEventWithDescription(PageEvents.OPEN_MOBILE_TROLLEY_MENU);
  };

  render() {
    const { basket, isLoggedIn } = this.props;

    // TODO Correct formatting for price issue with price=0
    const [basketValue, basketValueFraction] = priceFormatSeparate({ value: basket.value, inPound: true });

    const isEditing = basket.mode === basketModes.EDIT || basket.mode === basketModes.REORDER;
    const isValueBelowMinimum = basket.minimumOrderValue > basket.value;

    return (
      <div className={classNames('hd-basketSummary', { 'hd-basketSummary--editing': isEditing })}>
        <Link
          to={isLoggedIn ? links.DISPLAY_BASKET : links.DISPLAY_LOGGED_OUT_BASKET}
          className="hd-basketSummary__link"
          onClick={this.onBasketSummaryClick}
          title="Trolley"
          role="button"
        >
          <div className="hd-basketSummary__topLine">
            <div className="hd-basketSummary__total">
              {basketValue}<span className="hd-basketSummary__totalFraction">{basketValueFraction}</span>
            </div>
            {isValueBelowMinimum && (
              <div className="hd-basketSummary__minOrderValue">
                Min. order {priceFormat({ value: basket.minimumOrderValue, zeroAfterPound: false, inPound: true })}
              </div>
            )}
          </div>
          <div className="hd-basketSummary__bottomLine">
            <span className="hd-basketSummary__count">
              <span className="hd-basketSummary__countValue">{basket.numberOfItems}</span> items
            </span>
            <span className="hd-basketSummary__offer">
              savings <span>{priceFormat({ value: basket.offerSavings, inPound: true })}</span>
            </span>
          </div>
        </Link>
        <BasketSummaryEdit />
      </div>
    );
  }
}
